module.exports = __webpack_public_path__ + "img/stack-filter-inserter-platform.24397527.png";